import React, { useEffect, useState, useContext, useRef } from "react";
import { Link } from "react-router-dom";
import appProp from "../server";
import { EthersContext, contractInfo } from "../ethers/EthersProvider";
import "../css/base.css";
import "../css/main.css";
import "../css/instruction.css";
import title_img from "../img/title.png";
import img_man from "../img/man.png";
import img_woman from "../img/woman.png";
import leedo_project from "../img/leedo_favicon_32.png";

import Instruction from "../p_component/Instruction";
import AlertDiscord from "../p_component/AlertDiscord";

const postData = async (url = "", data = {}) => {
  return fetch(url, {
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    // credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json"
    },
    redirect: "follow",
    referrer: "no-referrer",
    body: JSON.stringify(data)
  }).then(response => response.json());
};

const Main = props => {
  const {
    provider,
    signer,
    account,
    setAccount,
    networkId,
    setNetworkId,
    verified,
    setVerified,
    initialized,
    setWalletConnect
  } = useContext(EthersContext);

  const [curAccount, setCurAccount] = React.useState(account);
  const [dicoAlert, setDicoAlertOpen] = React.useState(false);
  const [dicoId, setDicoId] = React.useState("");
  const [dicoTeam, setDicoTeam] = React.useState("");
  const [isRegisteredId, setIsRegisteredId] = React.useState(false);
  const [oldAddress, setOldAddress] = React.useState("");
  const [isPlayPaused, setPlayPause] = React.useState(false);

  useEffect(() => {
    setPauseGame("2022-04-21 00:00:00", "2022-04-22 00:00:00");
    // setPauseGame("2022-04-20 21:00:00", "2022-04-22 00:00:00");
  }, []);

  useEffect(() => {
    if (account !== undefined && account.length > 0) {
      if (curAccount !== account) {
        setCurAccount(account);
        checkUserInfo(account);
      }
    }
  }, [initialized, account]);

  const checkUserInfo = async _address => {
    let userInfo;
    if (_address !== null && _address.length > 0) {
      try {
        // console.log("checkUserInfo enter");
        userInfo = await postData(appProp.getuserinfoURL, {
          address: _address
        });
        // console.log("checkUserInfo userInfo => ", userInfo);
      } catch (error) {
        console.log(error);
      }
      // console.log("usserinfo => ", userInfo);
      // console.log("_address =>", _address);
      if (userInfo === null || userInfo === undefined) {
        try {
          // update User info
          let updateUserInfo = await postData(appProp.updateuserURL, {
            address: _address
          });
          // console.log("checkUserInfo updateUserInfo => ", updateUserInfo);
        } catch (error_userinfo) {
          console.log(error_userinfo);
        }
      }
      let targetUrl = window.location.href;
      let parsedurl = getURLParams(targetUrl);
      // console.log("parsedurl =>", parsedurl);
      if (parsedurl.discordid !== null && parsedurl.discordid !== undefined) {
        // visit from discord
        let _id = parsedurl.discordid.replace(/\'/gi, "");
        let _team = parsedurl.teamname.replace(/\'/gi, "");

        setDicoId(_id);
        setDicoTeam(_team);

        // dico id로 서치
        // 있으면 등록된 주소 있다는 alert
        // 없으면 등록 하겠냐는 alert

        try {
          // find discord id
          let findDicoInfo = await postData(appProp.finddiscordidURL, {
            discordid: _id
          });
          // console.log("findDicoInfo => ", findDicoInfo);
          if (findDicoInfo !== null && findDicoInfo !== undefined) {
            // 등록된 주소 있다.
            // console.log("findDicoInfo.Address =>", findDicoInfo[0].Address);
            // console.log("_address =>", _address);
            if (findDicoInfo[0].Address !== _address) {
              // 등록된 주소와 현재 주소가 같지 않으면 Alert display
              setOldAddress(findDicoInfo[0].Address);
              setIsRegisteredId(true);
              setDicoAlertOpen(true);
            } else {
              setDicoAlertOpen(false);
            }
          } else {
            // 등록된 주소 없다.
            setIsRegisteredId(false);
            setDicoAlertOpen(true);
          }
        } catch (error_dicoinfo) {
          console.log(error_dicoinfo);
        }
      }
    }
  };

  function setPauseGame(start_date, end_date) {
    var _StartDate = new Date(start_date);
    var _EndDate = new Date(end_date);
    var now = new Date();

    // console.log("start date => ", _StartDate);
    // console.log("end date => ", _EndDate);
    // console.log("now => ", now);

    if (_StartDate < now && now < _EndDate) {
      // Pause
      setPlayPause(true);
    } else {
      setPlayPause(false);
    }
  }

  function getURLParams(url) {
    var result = {};
    url.replace(/[?&]{1}([^=&]+)=([^&]*)/g, function (s, k, v) {
      result[k] = decodeURIComponent(v);
    });
    console.log("getURLParams  result =>", result);
    return result;
  }

  function connectWallet() {
    console.log("connect wallet");
    setWalletConnect(true);
  }

  const handleDicoAlertClose = () => {
    setDicoAlertOpen(false);
  };

  const updateDicoInfo = async (_address, _dicoid, _teamname) => {
    // console.log("updateDicoInfo _address =>", _address);
    // console.log("updateDicoInfo _dicoid =>", _dicoid);
    // console.log("updateDicoInfo _teamname =>", _teamname);
    try {
      // update User info
      let updateUserInfo = await postData(appProp.updateuserURL, {
        address: _address,
        discordid: _dicoid,
        teamname: _teamname
      });
    } catch (error_userinfo) {
      console.log(error_userinfo);
    }
    setDicoAlertOpen(false);
  };

  const LinkOpen = url => {
    window.open(url, "_blank");
  };

  return (
    <div id="index">
      <div className="wrap">
        <span className="backImg left">
          <img src={img_man} alt="" />
        </span>
        <span className="backImg right">
          <img src={img_woman} alt="" />
        </span>
        <content className="main_content">
          <header className="main_header">
            <img src={title_img} alt="" />
          </header>
          {window.ethereum == null ? (
            <div id="nowallet">
              <h3>
                You need an ethereum wallet extention to play this game ...
              </h3>
            </div>
          ) : (
            <nav id="menu">
              {isPlayPaused ? (
                <h1>
                  Pre Season game rankings are being calculated.<br></br>The
                  game can be restarted on 2022-02-22.
                </h1>
              ) : (
                ""
              )}

              <ul>
                <li className="zoomin">
                  {isPlayPaused ? (
                    ""
                  ) : initialized && account.length > 0 ? (
                    <Link to="/hanapegiplay">
                      <span className="triangle"></span>
                      Play
                    </Link>
                  ) : (
                    <label onClick={connectWallet}>
                      <span className="triangle"></span>
                      Connect wallet
                    </label>
                  )}
                </li>

                <li className="zoomin">
                  <Link to="/ranking">
                    <span className="triangle"></span>
                    Rankings
                  </Link>
                </li>

                <li className="zoomin">
                  <input type="checkbox" id="instruction_btn" />
                  <label htmlFor="instruction_btn">
                    <span className="triangle"></span>
                    Instruction
                  </label>
                  <div className="popup">
                    <div className="instruction_contents">
                      <label
                        htmlFor="instruction_btn"
                        className="close"
                      ></label>
                      <div className="text">
                        {/* <!-- instruction.html --> */}
                        <Instruction></Instruction>
                      </div>
                    </div>
                    <label htmlFor="instruction_btn"></label>
                  </div>
                  {dicoAlert ? (
                    <AlertDiscord
                      isRegisteredId={isRegisteredId}
                      oldAddress={oldAddress}
                      newAddress={curAccount}
                      discordId={dicoId}
                      teamName={dicoTeam}
                      closeAction={handleDicoAlertClose}
                      updateDicoInfo={updateDicoInfo}
                    ></AlertDiscord>
                  ) : (
                    ""
                  )}
                </li>
              </ul>
            </nav>
          )}
          <footer id="footer">
            <p>
              <a href="https://leedoproject.com/">
                <img src={leedo_project} alt="" />
                leedoproject.com
              </a>
            </p>
            <p id="copyright">copyrightⓒ2022 by CrazyBae.</p>
          </footer>
        </content>
      </div>
    </div>
  );
};
export default Main;
